var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGuide48Filled = function SvgIconGuide48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.3H11v3.4h26v-3.4ZM30.93 15.33l-3.55-3.55c-.5-.5-1.31-.5-1.81 0l-12.5 12.5-.95 4.8c-.18.89.61 1.68 1.5 1.5l4.8-.95 12.5-12.5c.5-.5.5-1.31 0-1.81l.01.01Z",
    fill: "current"
  })));
};
export default SvgIconGuide48Filled;